// dependencies
import { List } from "immutable";

// selectors
import { getUI } from "Selectors/ui";

export const getData = (state) => getUI(state).get("data", List());
export const getDataCount = (state) => getData(state).size;

export const getPageLimit = (state) => getUI(state).get("limit", 0);
export const getPageSize = (state) => getUI(state).get("pageSize", 1);
export const getCurrentPage = (state) => getUI(state).get("currentPage", 1);

/**
 * Gets the skip count based on the current page and limit
 */
export const getSkipCount = (state) => {
	const limit = getPageLimit(state);
	const currentPage = getCurrentPage(state);

	return (currentPage - 1) * limit;
};

/**
 * Calculate the page count
 */
export const getPageCount = (state) => {
	const usersCount = getDataCount(state);
	const limitCount = getPageLimit(state);

	return Math.ceil(usersCount / limitCount);
};
